import { api } from "@/api/client";

/* Phase 29 — Standalone Blueprint Design Engine (pay-to-play layout editor).
   Designs are authored as a JSON matrix; publishing spends Credits (unless
   entitled) and persists the matrix to the Vault under an asset_id. */
export const blueprintDesignApi = {
  entitlement: () => api.get("/blueprint-design/entitlement").then((r) => r.data),
  list: () => api.get("/blueprint-design/designs").then((r) => r.data),
  get: (id) => api.get(`/blueprint-design/designs/${id}`).then((r) => r.data),
  create: (title, matrix) => api.post("/blueprint-design/designs", { title, matrix }).then((r) => r.data),
  update: (id, patch) => api.put(`/blueprint-design/designs/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/blueprint-design/designs/${id}`).then((r) => r.data),
  publish: (id) => api.post(`/blueprint-design/designs/${id}/publish`).then((r) => r.data),
  render: (id) => api.post(`/blueprint-design/designs/${id}/render`).then((r) => r.data),
};
